import * as React from 'react'

import { BlankSlate, Box, Tag } from '@factorialco/deprecated-design-system'
import { groupBy, map } from 'lodash'

import { observer } from 'mobx-react'

import createAutorun from 'modules/core/hooks/createAutorun'
import createComputed from 'modules/core/hooks/createComputed'
import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import type IncidenceMessage from 'modules/bookkeepers/store/models/IncidenceMessage'

import MessageItem from './MessageItem'

interface Props {
  messages: IncidenceMessage[]
}

const messagesGroupingByDate = createComputed((messages: IncidenceMessage[]) => {
  return groupBy(messages, (message) => dateBackendDateTimeToUI(message.attributes.created_at))
})

const useAutoScroll = createAutorun((ref) => {
  return ref.current?.scrollIntoView({ behavior: 'smooth' })
})

const MessageList = ({ messages }: Props) => {
  const messageGroups = messagesGroupingByDate(messages).get()
  const messagesEndRef = React.createRef<HTMLDivElement>()
  useAutoScroll(messagesEndRef)

  return (
    <Box padding="s24" overflowY="auto">
      {messages.length !== 0 ? (
        <Box component="ul">
          {map(messageGroups, (groups, key) => (
            <Box component="li" gap="s16" key={key}>
              <Box alignItems="center">
                <Tag type="grey">{key}</Tag>
              </Box>
              <Box component="ul" gap="s16">
                {groups.map((item, key) => (
                  <MessageItem message={item} key={key} />
                ))}
              </Box>
            </Box>
          ))}
        </Box>
      ) : (
        <Box alignItems="center" justifyContent="center" paddingY="s96">
          <BlankSlate
            illustration="multiple-actions-mail"
            title={i18n.t('bookkeepers.incidence.message.no_messages_title')}
            description={i18n.t('bookkeepers.incidence.message.no_messages_description')}
          />
        </Box>
      )}
      <div ref={messagesEndRef} />
    </Box>
  )
}

export default observer(MessageList)
